var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount879859(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discount_879859",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182703",
    "data-name": "Group 182703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182702",
    "data-name": "Group 182702",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "up-arrow_3718346",
    d: "M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm4.33,8.832a.625.625,0,0,1-.884,0L10.625,6.011V15.5a.625.625,0,1,1-1.25,0V6.011L6.554,8.832a.625.625,0,0,1-.884-.884L9.558,4.06a.625.625,0,0,1,.884,0L14.33,7.948a.625.625,0,0,1,0,.884Z",
    fill: "#7d96ff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_182707",
    "data-name": "Group 182707",
    transform: "translate(6.25 11.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182706",
    "data-name": "Group 182706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49821",
    "data-name": "Path 49821",
    d: "M173.4,154.778a1.066,1.066,0,1,1,1.066-1.066A1.067,1.067,0,0,1,173.4,154.778Z",
    transform: "translate(-172.333 -152.646)",
    fill: "#7d96ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount879859);
export default __webpack_public_path__ + "static/media/discount_879859.7f9a88a0149536e1d55e0e95c769afc7.svg";
export { ForwardRef as ReactComponent };